import { NgModule } from '@angular/core';
import { RouterModule, Routes, CanActivate } from '@angular/router';

// Components
import { AppComponent } from './app.component';
import { LoginComponent } from './components/login/login.component';
import { ClinicComponent } from './components/clinic/clinic.component';
import { TreatmentComponent } from './components/treatment/treatment.component';
import { PractitionerComponent } from './components/practitioner/practitioner.component';
import { DateComponent } from './components/date/date.component';
import { TimeComponent } from './components/time/time.component';
import { DetailsComponent } from './components/details/details.component';
import { ConfirmationComponent } from './components/confirmation/confirmation.component';
import { PaymentComponent } from './components/payment/payment.component';
import { HomeComponent } from './components/home/home.component';
import { CabinetComponent } from './components/cabinet/cabinet.component';
import { ConfirmedComponent } from './components/confirmed/confirmed.component';
import { PasswordCreateComponent } from './components/password-create/password-create.component';
import { AppointmentComponent } from './components/appointment/appointment.component';

export const routes: Routes = [
  {
    path: ':id/login',
    component: LoginComponent
  },
  {
    path: ':id/clinic',
    component: ClinicComponent
  },
  {
    path: ':id/treatment',
    component: TreatmentComponent
  },
  {
    path: ':id/practitioner',
    component: PractitionerComponent
  },
  {
    path: ':id/date',
    component: DateComponent
  },
  {
    path: ':id/home',
    component: HomeComponent,
  },
  {
    path: ':id/time',
    component: TimeComponent
  },
  {
    path: ':id/details',
    component: DetailsComponent
  },
  {
    path: ':id/confirmation',
    component: ConfirmationComponent
  },
  {
    path: ':id/payment',
    component: PaymentComponent
  },
  {
    path: ':id/cabinet',
    component: CabinetComponent
  },
  {
    path: ':id/confirmed',
    component: ConfirmedComponent
  },
  {
    path: ':id/password/:hash',
    component: PasswordCreateComponent
  },
  {
    path: ':id/appointments',
    component: AppointmentComponent
  },
  {
    path: '',
    redirectTo: ':id/home',
    pathMatch: 'full'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {useHash: true})],
  exports: [RouterModule],
})
export class RoutingConfig {
}



// WEBPACK FOOTER //
// /Users/dtrubetskoi/Desktop/projects/online-booking-widget/src/app/app.routes.ts